module.exports = __webpack_public_path__ + "img/expostyle_9522_richelieu_red.8d37a952.jpg";